/* eslint-disable react/jsx-no-target-blank */
//import React from 'react'
//import { useIntl } from 'react-intl'
//import {KTSVG} from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuth } from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  //const intl = useIntl()
  const { currentUser } = useAuth()
 
  return (
    <>
      <SidebarMenuItemWithSub to='/principal' title='Bases transversales'>
        <SidebarMenuItem
          to='/Testimonial/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Testimoniales'
          fontIcon='bi-app-indicator'
        />
        {/*
        <SidebarMenuItem
          to='/Organizaciones/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Documentales'
          fontIcon='bi-app-indicator'
        />
  */}
      </SidebarMenuItemWithSub>
      {(currentUser?.role == 1 || currentUser?.role == 2 || currentUser?.role == 4) &&
      <SidebarMenuItemWithSub to='/Etiquetas' title='Busqueda por Etiquetas'>
        {/* <SidebarMenuItem
          to='/dashboard'
          icon='/media/icons/duotune/art/art002.svg'
          title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
          fontIcon='bi-app-indicator'
        /> */}
        <SidebarMenuItem
          to='/Etiquetas/AnalisisContexto/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Análisis de contexto'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/Etiquetas/Estrategias/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Estrategias'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/Etiquetas/Consecuencias/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Consecuencias'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/Etiquetas/Causas/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Causas'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          /* to='/Etiquetas/Responsables/' */
          to='#'
          icon='/media/icons/duotune/art/art002.svg'
          title='Responsables'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/Etiquetas/Factores/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Factores de persistencia'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          /* to='/Etiquetas/Corrupcion/' */
          to='#'
          icon='/media/icons/duotune/art/art002.svg'
          title='Corrupción e impunidad'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          /* to='/Etiquetas/Corrupcion/' */
          to = '#'
          icon='/media/icons/duotune/art/art002.svg'
          title='Enfoque de Género'
          fontIcon='bi-app-indicator'
        />
      </SidebarMenuItemWithSub>
}
      {(currentUser?.role == 1) &&
      <SidebarMenuItemWithSub to='/catalogos' title='Cruces'>
        <SidebarMenuItem
          to='/Victimas/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Víctimas'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/GravesViolaciones/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Eventos'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/GravesViolaciones/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Responsables estatales'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/GravesViolaciones/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Responsables privados'
          fontIcon='bi-app-indicator'
        />
      </SidebarMenuItemWithSub>
}
{(currentUser?.role == 1) &&
      <SidebarMenuItemWithSub to='/principal' title='Casos'>
        <SidebarMenuItem
          to='/Personas/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Casos potenciales'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/Organizaciones/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Bases de datos de casos por Equipo'
          fontIcon='bi-app-indicator'
        />
      </SidebarMenuItemWithSub>
}
{(currentUser?.role == 1) &&
      <SidebarMenuItemWithSub to='/principal' title='Otras bases de datos por equipo'>
        <SidebarMenuItem
          to='/Personas/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Personas'
          fontIcon='bi-app-indicator'
        />
      </SidebarMenuItemWithSub>
}      
{(currentUser?.role == 1) &&
      <SidebarMenuItemWithSub to='/principal' title='Catálogos'>
        <SidebarMenuItem
          to='/CatalogoEtiquetas/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Catálogo de Etiquetas'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/OrganizacionesInsurgentes/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Catálogo de Organizaciones insurgentes y de víctimas'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/AgenciasEstatales/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Catálogo de Agencias estatales'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/ZonasMilitares/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Catálogo de Zonas Militares'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/GravesViolaciones/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Catálogo de Graves Violaciones'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/CondicionesDiferenciadoras/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Catálogo de Condiciones Diferenciadoras'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/Subcontextos/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Catálogo de Subcontextos'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/Organizaciones/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Catálogo de Organizaciones'
          fontIcon='bi-app-indicator'
        />
        <SidebarMenuItem
          to='/Personas/'
          icon='/media/icons/duotune/art/art002.svg'
          title='Catálogo de Personas'
          fontIcon='bi-app-indicator'
        />
      </SidebarMenuItemWithSub>
}
    </>
  )
}

export { SidebarMenuMain }